import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  Component,
  ElementRef,
  HostListener,
  Input,
  PLATFORM_ID,
  ViewChild,
  inject
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-menu-stick',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './menu-stick.component.html',
  styleUrl: './menu-stick.component.scss'
})
export class MenuStickComponent {
  @Input() language = 'es';
  @Input() children = false;
  @Input() parentUrl = '';
  @Input() items = [];
  color = '#003366';
  icon = '';
  svgContent:any;
  @ViewChild('navBar', { static: false }) navBarElement!: ElementRef;
  
  isSticky = false;
  isMenuOpen = false;
  navHeight = 0;

  private platformId = inject(PLATFORM_ID);
  private document = inject(DOCUMENT);
  private stickyScrollPoint: number = 0;

  private _venue: any;

  @Input()
  set venue(value: any) {
    this._venue = value;
    this.alCambiarVenue(value); 
  }

  get venue(): any {
    return this._venue;
  }

  private alCambiarVenue(info: any): void {
    this.color = info.venue.color;
    this.icon = info.venue.icono;
    this.loadSvg();
   }

  constructor(private route: ActivatedRoute,private sanitizer: DomSanitizer,private http:HttpClient) {}

  ngOnInit(): void { 
    this.route.queryParams.subscribe(params => {
      const widgetId = params['widget'];
      
      if (widgetId) {
        setTimeout(() => {
          this.anchorScroll(widgetId);
        }, 1000); 
      }
    });
  }

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    if (!isPlatformBrowser(this.platformId) || !this.navBarElement) return;

    const navElement = this.navBarElement.nativeElement;
    const rect = navElement.getBoundingClientRect();
    const scrollTop = this.document.documentElement.scrollTop || this.document.body.scrollTop;
    const headerContainer = this.document.getElementById('header-container');

    if (!this.isSticky && rect.top <= 0) {
      this.navHeight = navElement.offsetHeight;
      this.stickyScrollPoint = scrollTop; 
      this.setHeaderVisibility(headerContainer, true);
      this.isSticky = true;
    } else if (this.isSticky && scrollTop < this.stickyScrollPoint) {
      this.isSticky = false; 
      this.setHeaderVisibility(headerContainer, false);
    }
  }

  private setHeaderVisibility(headerContainer: HTMLElement | null, hidden: boolean): void {
    if (!headerContainer) return;

    headerContainer.style.transition = hidden ? 'none' : 'transform 0.35s ease';
    headerContainer.style.willChange = hidden ? '' : 'transform';
    headerContainer.style.opacity = '';
    headerContainer.style.visibility = hidden ? 'hidden' : 'visible';
    headerContainer.style.pointerEvents = hidden ? 'none' : '';
    headerContainer.style.transform = '';
  }

  handleClick(event: Event, btn: any): void {
    if (!btn) return;

    // Cierra el menú al presionar una opción en mobile
    this.isMenuOpen = false;

    if (btn.typeLink === 'anchor' && !this.children) {
      event.preventDefault();
      const targetId = btn.anchorWidget || btn.id || btn.link;
      this.anchorScroll(targetId);
    }

    if (btn.typeLink === 'anchor' && this.children) {
      event.preventDefault();
      const targetId = btn.anchorWidget || btn.id || btn.link;
      const urlString = this.url({ link: this.parentUrl + "?widget=" + targetId });

      if (urlString) {
        window.open(urlString, '_blank', 'noopener,noreferrer');
      }
      return;
    }

    if (btn.typeLink === 'url') {
      event.preventDefault();
      const urlString = this.url(btn);

      if (urlString) {
        window.open(urlString, '_blank', 'noopener,noreferrer');
      }
    }
  }

  isExternalUrl(urlStr: string): boolean {
    return urlStr.startsWith('http://') || urlStr.startsWith('https://');
  }

  url(element: any): string {
    let link = element.link || element.route || element.systemTitle || '';

    if (!link) return '';

    if (this.isExternalUrl(link)) {
      return link;
    }

    if (link.startsWith('/')) {
      link = link.substring(1);
    }

    return `/${this.language}/${link}`;
  }

  anchorScroll(targetId: string) {
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      const navbarHeight = (this.navBarElement?.nativeElement?.offsetHeight) + 15 || 50;
      const mainHeader = document.querySelector('#header-container');
      const mainHeaderHeight = mainHeader ? mainHeader.getBoundingClientRect().height : 0;
      const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - navbarHeight - mainHeaderHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    } else {
      console.warn(`No se encontró ningún elemento con id: "${targetId}"`);
    }
    return;
  }

   
    ngAfterViewInit(): void {
    this.loadSvg();
  }
 
  loadSvg(): void {
    this.http.get(this.icon, { responseType: 'text' }).subscribe(svg => {
      const modifiedSvg = this.changeSvgColor(svg, '#ffffff');
      this.svgContent = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/svg+xml,' + encodeURIComponent(modifiedSvg));
    });
  }

  changeSvgColor(svg: string, color: string): string {
    return svg.replace(/fill: #[0-9a-fA-F]{6};/g, `fill: ${color};`);
  }
}
